module.exports = __webpack_public_path__ + "static/media/Corp.a7a872ec.jpg";